import React, { useState } from 'react';
import './StarRating.scss';

interface StarRatingProps {
  count: number;
  value: number;
  onChange: (newValue: number) => void;
}

const StarRating: React.FC<StarRatingProps> = ({ count, value, onChange }) => {
  const [hoverValue, setHoverValue] = useState<number | null>(null);
  const [isAnimating, setIsAnimating] = useState<boolean>(false);

  const handleStarClick = (starValue: number) => {
    setIsAnimating(true);
    onChange(starValue);
    setTimeout(() => setIsAnimating(false), 300);
  };

  return (
    <div className="stars-container">
      {[...Array(count)].map((_, index) => {
        const starValue = index + 1;
        const isHovered = hoverValue !== null && hoverValue >= starValue;
        const isSelected = value >= starValue;
        const showPreview = isHovered && hoverValue !== null; // Show preview on hover
        
        return (
          <div
            key={index}
            className={`star-wrapper ${showPreview ? 'active' : ''} ${isSelected ? 'selected' : ''} ${isAnimating && isSelected ? 'animating' : ''}`}
            style={{
              animationDelay: `${index * 0.1}s`
            }}
            onClick={() => handleStarClick(starValue)}
            onMouseEnter={() => setHoverValue(starValue)}
            onMouseLeave={() => setHoverValue(null)}
          >
            <span className="star-background">★</span>
            <span className="star-fill">★</span>
            <div className="star-glow"></div>
          </div>
        );
      })}
    </div>
  );
};

export default StarRating;
